export default __webpack_public_path__ + "static/media/csv2.a568170c.svg";